module.exports = __webpack_public_path__ + "static/media/timewall.0d4427ed.png";